import React, { useEffect, useRef, useState } from 'react';
import { useSpring, useTransition, animated } from '@react-spring/web';
import { Link, useNavigate } from 'react-router-dom';
import { uploadVideoToCloudinary } from './utils/cloudinaryUtils';
import axios from 'axios';

// import UploadVideoForm from "./UploadVideoForm";
// import imgBtnGallery from "../assets/img/whp-btn-see-washers.png";

import imgLoadingEquialize from "../assets/img/whp-loading-equialize.svg";


function ProgressBar({ isLoading, progress }) {
    const springProps = useSpring({
        width: `${progress.toFixed(0)}%`,
        from: { width: '0%' },
    });

    return (
        <div className="progress-bar-container mt-3">
            <animated.div className="progress-bar" style={springProps} />
            <span className="progress-text">{isLoading ? `${progress.toFixed(0)}%` : 'Completado'}</span>
        </div>
    );
}

const UploadSection = () => {
    const navigate = useNavigate();

    const props = useSpring({
        opacity: 1,
        transform: `translateY(0%)`,
        from: { opacity: 0, transform: `translateY(100%)` },
    });

    useEffect(() => {
        setCurrentStep(0);
    }, []);

    const [currentStep, setCurrentStep] = useState(0);
    const transitions = useTransition(currentStep, {
        keys: currentStep,
        from: { opacity: 0, transform: 'translateY(100%)' },
        enter: { opacity: 1, transform: 'translateY(0)' },
        leave: { opacity: 0, transform: 'translateY(-100%)' },
        config: { duration: 300 },
    });

    const [isProcessing, setIsProcessing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    const [error, setError] = useState('');
    const [years, setYears] = useState('');
    // const [email, setEmail] = useState('');
    const [selectedBrand, setSelectedBrand] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(true);
    const [isValidEmail, setIsValidEmail] = useState(false);
    const fileInputRef = useRef(null);

    const [currentMessage, setCurrentMessage] = useState('Estamos procesando la vibración de tu lavadora');


    const brands = [
        'Whirlpool',
        'Acros',
        'Maytag',
        'Otros'
    ];

    const handleSelectChange = (e) => {
        setSelectedBrand(e.target.value);
        setError('');
    };

    const handleInputChange = (e) => {
        setYears(e.target.value);
        setError('');
    };

    const handleNextStep = (event) => {
        event.preventDefault();

        if (selectedBrand === '' || !termsAccepted || !years) {
            setError('Verifica todos los datos antes de avanzar.');
            return;
        }

        setCurrentStep(prev => prev + 1);
    };

    let startTime = null;
    const handleFileChange = async (e) => {
        const selectedFile = e.target.files[0];
        const allowedVideoTypes = [
            'video/mp4', 'video/webm', 'video/ogg', 'video/quicktime', 'video/x-m4v', 'video/3gpp', 'video/3gpp2'
        ];
        if (!allowedVideoTypes.includes(selectedFile.type)) {
            setError('Por favor, selecciona un archivo de video válido.');
            fileInputRef.current.value = '';
            return;
        }

        const fileSizeInMB = selectedFile.size / 1024 / 1024;
        if (fileSizeInMB > 30) {
            setError('Lo sentimos, tu video debe ser menos a 30MB.');
            fileInputRef.current.value = '';
            return;
        }

        try {
            setIsProcessing(true);
            setIsLoading(true);
            startTime = Date.now();

            const updateProgress = (newProgress) => {
                setProgress(newProgress);
                if (newProgress >= 98) {
                    clearInterval(progressInterval); // Detener el intervalo al llegar al 90%
                }
            };

            const progressInterval = setInterval(() => {
                const elapsedTime = Date.now() - startTime;
                const newProgress = Math.min(90, (elapsedTime / 90000) * 90);
                updateProgress(newProgress);
            }, 100);

            setCurrentMessage('Estamos procesando la vibración de tu lavadora.');
            const { secureUrl, publicId } = await uploadVideoToCloudinary(selectedFile);

            const formData = new FormData();
            formData.append('public_id', publicId);
            formData.append('secureUrl', secureUrl);
            formData.append('type', 'whp_video_s1');
            formData.append('years', years);
            formData.append('email', 'N/A');
            formData.append('brand', selectedBrand);
            formData.append('acceptTerms', termsAccepted);
            formData.append('acceptFollowUp', 'N/A');

            setCurrentMessage('Estamos analizando los pasos de tu bailarina.');
            const res_1 = await axios.post(process.env.REACT_APP_LAMBDA_ENDPOINT, formData);
            if (!res_1.data.success) {
                throw new Error(res_1.data.message);
            }

            formData.set('_id', res_1.data.data._id);
            formData.set('beat', res_1.data.data.audio.beat);
            formData.set('secureUrl', res_1.data.data.video.secure_url);
            formData.set('type', 'whp_video_s2');

            setCurrentMessage('Estamos detectando el bailongo de tu lavadora.');
            const res_2 = await axios.post(process.env.REACT_APP_LAMBDA_ENDPOINT, formData);
            if (!res_2.data.success) {
                throw new Error(res_2.data.message);
            }

            formData.set('_id', res_2.data.data._id);
            formData.set('s3Url', res_2.data.data.s3Url);
            formData.set('type', 'whp_video_s3');

            setCurrentMessage('Estamos determinando el meneito de tu bailarina.');
            const res_3 = await axios.post(process.env.REACT_APP_LAMBDA_ENDPOINT, formData);
            if (!res_3.data.success) {
                throw new Error(res_3.data.message);
            }

            navigate(`/videos/${res_3.data.data._id}?code`);

        } catch (error) {
            //setIsProcessing(false);
            if (error.status === 502) {
                setError("Tuvimos un problema al analizar tu video, intentalo de nuevo.");
            } else {
                setError("Lo sentimos, no detectamos tu meneito. Vuelve a intentarlo.");
                //setError(error.message);
            }
        } finally {
            setIsProcessing(false);
            setIsLoading(false);
            fileInputRef.current.value = '';
        }
    }

    const modalAnimation = useSpring({
        opacity: isProcessing ? 1 : 0,
        transform: isProcessing ? 'scale(1)' : 'scale(0)',
        config: { tension: 200, friction: 20 },
    });

    return (
        <>
            <animated.div id="uploadSection" className="sectionItem d-flex align-items-center" style={{ ...props }}>
                <div className="container">
                    <div className="row">
                        <div className='col-10 offset-1 col-md-6 offset-md-3 text-center'>
                            <form className='form-redesigned' >
                                {transitions((style, slidePosition) => (
                                    <animated.div style={style}>
                                        {slidePosition === 0 ? (<>
                                            <h3>Ahora cuéntanos...</h3>
                                            <p className='mb-3 mb-md-4'>La edad y marca de bailarina, perdón lavadora que tengas
                                                nos ayudara a analizar que sabor de cumbia merece.</p>
                                            <div className='form-control mb-3'>
                                                <label>Edad de tu lavadora</label>
                                                <input type='number' placeholder='Eje. 52'
                                                    value={years}
                                                    onChange={handleInputChange} />
                                            </div>
                                            <div className='form-control mb-3'>
                                                <label>Marca de tu lavadora</label>
                                                <select type='number'
                                                    value={selectedBrand}
                                                    onChange={handleSelectChange}>
                                                    <option value="">Selecciona la marca de tu lavadora</option>
                                                    {brands.map((brand, index) => (
                                                        <option key={index} value={brand}>
                                                            {brand}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="legales mt-md-4">
                                                <div className="form-check text-start">
                                                    <input className="form-check-input" type="checkbox" value="" id="cbTermsConditions"
                                                        checked={termsAccepted}
                                                        onChange={(e) => { setError(''); setTermsAccepted(e.target.checked) }} />
                                                    <label className="form-check-label" htmlFor="cbTermsConditions">
                                                        He leído y acepto los <Link to='/termsConditions' target="_blank">Términos y Condiciones de la Actividad</Link> y el <Link to='/privacyPolicy' target="_blank">Aviso de Privacidad</Link> Whirlpool.
                                                    </label>
                                                </div>
                                            </div>

                                            <button className='btn btn-primary mt-4' onClick={handleNextStep}>
                                                Continuar
                                            </button>
                                        </>) : (<>
                                            <h3>¡Ahora sí!</h3>
                                            <p className='mb-3 mb-md-5'>Graba tu video y súbelo  para analizar
                                                que ritmo trae tu lavadora </p>
                                            <input
                                                type="file"
                                                className="uploadFile"
                                                style={{ display: 'none' }}
                                                ref={fileInputRef}
                                                onChange={(e) => handleFileChange(e)}
                                                accept="video/*"
                                                disabled={isProcessing}
                                            />
                                            <button type="button" className="btn btn-inputFile" onClick={() => fileInputRef.current.click()}>
                                                Subir archivo
                                            </button>
                                            <div className='disclaimer mt-5'>
                                                <p>¿Quieres ver el bailongo para inspirarte?</p>
                                                <Link className='btn btn-primary opacity-1' to='/gallery' >
                                                    Ver lavadoras
                                                </Link>
                                            </div>
                                        </>)}

                                    </animated.div>
                                ))}
                                {error && <p className="text-danger mt-3">{error}</p>}
                            </form>

                        </div>
                    </div>
                </div>
            </animated.div>

            {isProcessing && (
                <animated.div className="loading-video" style={{
                    ...modalAnimation,
                }} onClick={(e) => e.stopPropagation()}>
                    <div className="row">
                        <div className="col-10 offset-1 col-md-6 offset-md-3">
                            <h3 className="mb-3 text-center">{currentMessage}</h3>
                        </div>
                        <div className="col-10 offset-1 col-md-6 offset-md-3">
                            <img src={imgLoadingEquialize} alt="Loading Equialize" className="loading-equialize mx-auto d-block" />
                            <div className='w-75 mx-auto mt-3 mt-md-5'>
                                {isLoading && <ProgressBar isLoading={isLoading} progress={progress} />}
                            </div>
                        </div>
                    </div>
                </animated.div >
            )}
        </>
    );
};

export default UploadSection;